// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1_COh","chart":"chart__2aSs8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScatterChart/styles.scss
// module id = 2145
// module chunks = 1